import type { ICity } from '../models';

export class CITIES_CONFIG {
  static readonly EXPIRED_TIME = 1000 * 60 * 60 * 24; // 1day
  static readonly FALLBACK_CENTER_COORD = [49.103902, 55.798958]; // Kazan
  static readonly FALLBACK_CITY: ICity = {
    id: 1,
    name: 'Казань',
    deliveryPrice: null,
    deliveryPoints: [],
    deliveryTypes: [],
    fiasId: '93b3df57-4c89-44df-ac42-96f05e9cd3b9',
  };
}
